// Kraj wersji serwisu (decyzja 2026-10-07: jedna aplikacja, kraje w katalogach adresu).
//
// Polska nie ma prefiksu (voltvalue.pl/...). Inny kraj ma prefiks w adresie
// (voltvalue.eu/ro/...). Kraj ustalamy RAZ przy starcie aplikacji: zmiana kraju to
// przejście na inny adres, więc przeładowanie strony, a nie stan w pamięci.
//
// Kraj wpływa na trzy rzeczy:
//  - dane: nagłówek X-VV-Country w zapytaniach do API (api/apiFetch.js), backend
//    wybiera wtedy schemat bazy z ofertami i cenami tego kraju;
//  - teksty: język słowników w src/locales (src/i18n.js);
//  - liczby i kwoty: locale i waluta (formatPrice, formatKwota w utils.js).

export const KRAJE = {
  pl: { kod: 'pl', jezyk: 'pl', locale: 'pl-PL', waluta: 'PLN', symbol: 'zł', prefiks: '', kursPln: 1 },
  ro: { kod: 'ro', jezyk: 'ro', locale: 'ro-RO', waluta: 'RON', symbol: 'lei', prefiks: '/ro', kursPln: 1.18 },
};

export const krajZAdresu = (pathname) => {
  const p = pathname || '';
  const znaleziony = Object.values(KRAJE).find(
    (k) => k.prefiks && (p === k.prefiks || p.startsWith(`${k.prefiks}/`))
  );
  return znaleziony || KRAJE.pl;
};

export const KRAJ = krajZAdresu(typeof window !== 'undefined' ? window.location.pathname : '');

export const jestPolska = KRAJ.kod === 'pl';

// Polskie cenniki (konstrukcja, montaż) w walucie kraju, dopóki kraj nie ma własnych
// (decyzja właściciela 2026-10-08). `kursPln` to ile jednostek waluty kraju za 1 zł;
// 1,18 lei to kurs z października 2026 zaokrąglony w dół. W Polsce zwraca liczbę bez zmian.
export const zZlotych = (kwotaZl) => (kwotaZl == null ? kwotaZl : kwotaZl * KRAJ.kursPln);

// Klucz w sessionStorage/localStorage dla danych zależnych od kraju (wybrane modele,
// filtry). Kraje pod voltvalue.eu (/ro/, /de/...) dzielą jedną domenę, więc bez
// prefiksu wybór rumuńskiego modelu wracał na innej wersji z obcym id. Polska zostaje
// przy dotychczasowych kluczach, żeby nie zgubić zapisanych wyborów użytkowników.
export const kluczKraju = (klucz) => (jestPolska ? klucz : `${KRAJ.kod}:${klucz}`);
